import { HOSTING } from "@/lib/constants";

// Classify hosting type based on URL.
// - emergent.host / preview.emergentagent.com → EMERGENT
// - anything else with a host → OWN
// - empty / invalid → NONE
export function classifyHosting(rawUrl) {
  const url = (rawUrl || "").trim();
  if (!url) return HOSTING.NONE;
  const lower = url.toLowerCase();
  if (lower.includes("emergent.host") || lower.includes("emergentagent.com")) {
    return HOSTING.EMERGENT;
  }
  // Looks like a domain at all?
  if (/[a-z0-9-]+\.[a-z]{2,}/i.test(url)) {
    return HOSTING.OWN;
  }
  return HOSTING.NONE;
}

export function getHostingLabel(type) {
  if (type === HOSTING.OWN) return { icon: "🌐", text: "EIGENE DOMAIN" };
  if (type === HOSTING.EMERGENT) return { icon: "⚡", text: "EMERGENT" };
  return { icon: "📝", text: "OHNE URL" };
}
